import React from 'react'

import { i18n } from '~/i18n'
import formatCurrency from '~/utils/format-currency'

import { ProductLine, ProductPrice, OrderPassInsurance } from './v3.styles'

import type { CartAddon } from '~/types'

type Props = {
  appliedAddons: CartAddon[]
}

export default function AppliedAddonRows({ appliedAddons }: Props) {
  return (
    <>
      {appliedAddons.map(({ price, product, type }) => (
        <ProductLine key={product + type} data-testid="addon-line">
          <OrderPassInsurance>
            {i18n.t(`addons.${product}.applied_read_only`)}
          </OrderPassInsurance>
          <ProductPrice>{formatCurrency(price)}</ProductPrice>
        </ProductLine>
      ))}
    </>
  )
}
